module.exports = __webpack_public_path__ + "img/Logo-15.7a135066.svg";